import React, { useState, useEffect } from "react";
import ProcessCardDoctors from "./ProcessCardDoctors";
import Grid from "@mui/material/Unstable_Grid2";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";

const ProcessCardContainerDoctors = (props) => {
  const orderTypeProcesses = props.orderTypeProcesses;
  const orderProcesses = props.orderProcesses;
  const [isLoading, setisLoading] = useState(true);
  const taskList = [];
  const uniqueTaskIds = new Set();

  //logic for creating tasks
  const taskListHandler = (id, orderProcesses) => {
    const processIds = [];
    //getting the task for the input task ID
    const matchedTasks = orderProcesses.filter((p) => p.taskId == id);

    //getting process IDs for each process
    matchedTasks.forEach((process) => {
      processIds.push(process.orderTypeProcessId);
    });

    const lastProcess = matchedTasks[matchedTasks.length - 1];
    const endDate = lastProcess.endDate;
    const startDate = lastProcess.startDate;
    const predictionDate = lastProcess.predictionDate;
    const isDone = endDate ? true : false;
    const finishDate = isDone ? endDate : predictionDate;
    const upRight = lastProcess.upRight;
    const jawCount = lastProcess.jawCount;
    const unitCount = lastProcess.unitCount;
    const upLeft = lastProcess.upLeft;
    const downRight = lastProcess.downRight;
    const downLeft = lastProcess.downLeft;
    const entryDescription = lastProcess.entryDescription;
    const exitDescription = lastProcess.exitDescription;

    return {
      processIds,
      startDate,
      finishDate,
      isDone,
      upRight,
      jawCount,
      unitCount,
      upLeft,
      downRight,
      downLeft,
      entryDescription,
      exitDescription,
    };
  };

  //getting unique task ids
  orderProcesses?.forEach((process) => {
    uniqueTaskIds.add(process.taskId);
  });

  //creating task list
  [...uniqueTaskIds]?.forEach((id) => {
    taskList.push(taskListHandler(id, orderProcesses));
  });

  //handling is loading
  useEffect(() => {
    taskList && setisLoading(false);
  }, [taskList]);

  //test
  // useEffect(() => {
  //   console.log(taskList);
  // }, [taskList]);

  return (
    <>
      {" "}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {!isLoading && (
        <Grid container spacing={2}>
          {taskList.map((task, i) => {
            return (
              <Grid xs={12} md={12} key={i}>
                <ProcessCardDoctors
                  task={task}
                  id={i}
                  orderTypeProcesses={orderTypeProcesses}
                />
              </Grid>
            );
          })}
        </Grid>
      )}
    </>
  );
};

export default ProcessCardContainerDoctors;
